import { QuestionnaireStatus } from 'src/graphql';

export type FormDetailHeaderActionFlags = {
  showAuditLog: boolean;
  showArchive: boolean;
  archiveDisabled: boolean;
  showDuplicate: boolean;
  showEdit: boolean;
  showUnpublish: boolean;
};

export type FormDetailHeaderActionOptions = {
  isCoiForm?: boolean;
};

function normalizeQuestionnaireStatus(
  status: string | null | undefined,
): string {
  return (status ?? '').toUpperCase();
}

export function getFormDetailHeaderActionFlags(
  questionnaireStatus: string | null | undefined,
  options: FormDetailHeaderActionOptions = {},
): FormDetailHeaderActionFlags {
  switch (normalizeQuestionnaireStatus(questionnaireStatus)) {
    case QuestionnaireStatus.Draft:
      return {
        showAuditLog: true,
        showArchive: false,
        archiveDisabled: false,
        showDuplicate: true,
        showEdit: true,
        showUnpublish: false,
      };
    case QuestionnaireStatus.Active:
      return {
        showAuditLog: true,
        showArchive: false,
        archiveDisabled: false,
        showDuplicate: true,
        showEdit: false,
        showUnpublish: options.isCoiForm === true,
      };
    case QuestionnaireStatus.Archived:
      return {
        showAuditLog: true,
        showArchive: false,
        archiveDisabled: false,
        showDuplicate: true,
        showEdit: false,
        showUnpublish: false,
      };
    case QuestionnaireStatus.Inactive:
      return {
        showAuditLog: true,
        showArchive: true,
        archiveDisabled: false,
        showDuplicate: true,
        showEdit: false,
        showUnpublish: false,
      };
    default:
      return {
        showAuditLog: true,
        showArchive: false,
        archiveDisabled: false,
        showDuplicate: true,
        showEdit: true,
        showUnpublish: false,
      };
  }
}
